import React, { useState, useEffect } from "react";
import { Button, Col, Descriptions, Divider, Form, InputNumber, Layout, Skeleton, Row, Table, Tag, Typography } from 'antd';
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import { inject, observer } from 'mobx-react'
import "./style.scss";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment-timezone";
import { cloneDeep } from "lodash";

const { Content } = Layout;
const { Text } = Typography;

const ViewLeaderReport = ({ voterStore }) => {

  const { Title } = Typography;
  const navigate = useNavigate();
  let { id } = useParams();

  const [showData, setShowData] = useState(false);

  useEffect(() => {
    voterStore.page = 1;
    voterStore.hasMore = false;
    voterStore.perPage = 10;
    if(id){
      voterStore.fetchVoterByID(id);
      voterStore.fetchVoterAmountByID(id);
    }
  }, [id]);

  useEffect(() => {
    voterStore.page = 1;
    voterStore.hasMore = false;
    voterStore.perPage = 10;
    
    const timeout = setTimeout(() => {
      setShowData(true);
    }, 500);

    return () => clearTimeout(timeout);

  }, []);

  const handlePrevPage = () => {
    voterStore.page = voterStore.page - 1;
    if(id){
      voterStore.fetchVoterAmountByID(id);
    }
  };

  const handleNextPage = () => {
    voterStore.page = voterStore.page + 1;
    if(id){
      voterStore.fetchVoterAmountByID(id);
    }
  };

  const formatNumber = (formatnumber) => {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(formatnumber);
  };

  const columns = [
      {
        title: 'Type',
        dataIndex: 'Type',
        key: 'Type',
        render: (Type) => (
          <Tag color={'green'}><Text type="primary" strong>{Type}</Text></Tag>
        )
      },
      {
        title: 'Event',
        key: 'EventName+VotersAmountID',
        dataIndex: 'EventName',
        responsive: ['lg', 'xl', 'md'],
        render: (EventName) => (
          <Text default>{EventName}</Text>
        )
      },
      {
        title: 'Name',
        dataIndex: 'ItemName',
        key: 'ItemName',
        render: (ItemName) => (
          <Text type="primary" strong>{ItemName ? ItemName : "Cash"}</Text>
        )
      },
      {
        title: 'PPU',
        dataIndex: 'PricePerUnit',
        key: 'PricePerUnit',
        render: (PricePerUnit) => (
          <Text type="primary" strong>{PricePerUnit ? PricePerUnit : "-"}</Text>
        )
      },
      {
        title: 'Quantity',
        dataIndex: 'Quantity',
        key: 'Quantity',
        render: (Quantity) => (
          <Text type="primary" strong>{Quantity ? Quantity : "-"}</Text>
        )
      },
      {
        title: 'Amount',
        key: 'Amount+VotersAmountID',
        dataIndex: 'Amount',
        responsive: ['lg', 'xl', 'md'],
        render: (Amount, record) => (
          <Text default strong>₱{formatNumber(Amount)}</Text>
        )
      },
      {
        title: 'Transaction Date',
        key: 'CreatedAt+VotersAmountID',
        dataIndex: 'CreatedAt',
        responsive: ['lg', 'xl', 'md'],
        render: (CreatedAt) => (
          <Text default>{moment.utc(CreatedAt).format("MMM DD, YYYY")}</Text>
        )
      },
      {
        title: 'Transact By',
        key: 'LoadedBy+VotersAmountID',
        dataIndex: 'LoadedBy',
        responsive: ['lg', 'xl', 'md'],
        render: (LoadedBy) => (
          <Tag><Text type="primary" strong>{LoadedBy}</Text></Tag>
        )
      },
    ];

  return (
    <div className="view-teamleadersreport">
      <Content>
        <div className="view-teamleadersreport-content">
          <Title level={4}>Leaders Report Details</Title>
          <Divider />
          {
            showData ? (
              <>
                <Title level={5}>Visited Events</Title>
                <Table pagination={false} columns={columns} dataSource={voterStore.votersAmounts} bordered/>
                <ul className="pagination">
                  <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={voterStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
                  <li className="pagination-item"><a>{voterStore.page}</a></li>
                  <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={voterStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
                </ul>
              </>
            ) : <Skeleton active/>
          }
          <Divider/>
          <Row justify={'end'} gutter={10}>
            <Col>
              <Button onClick={() => navigate(-1)}>Back</Button>
            </Col>
          </Row>
        </div>
      </Content>
    </div>

  );
};

export default inject('voterStore')(observer(ViewLeaderReport));
